import { ViewTypesNames } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const getReturnViewNotificationCounts = {
  name: "getReturnViewNotificationCounts" as const,
  input: z.object({
    viewIds: z.array(z.string()).default([]),
    /** Count every requested view, not only the ones with notifications on. */
    includeAll: z.boolean().optional(),
    type: z.union([
      z.literal(ViewTypesNames.RETURNS),
      z.literal(ViewTypesNames.CLAIMS),
      z.literal(ViewTypesNames.WARRANTIES),
      z.literal(ViewTypesNames.RECYCLE),
      z.literal(ViewTypesNames.WITHDRAWALS),
    ]),
  }),
  output: z.object({ counts: z.record(z.string(), z.number()) }),
};
